/**
 * CustomSelect class
 *
 * @package    DataTable
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl/FormControl';
import InputLabel from '@material-ui/core/InputLabel/InputLabel';

import selectStyle from './styles.jsx';

@withStyles(selectStyle)
export default class CustomSelect extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        classes: PropTypes.object.isRequired,
        options: PropTypes.array.isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
        onChange: PropTypes.func.isRequired,
        placeholder: PropTypes.string,
        formControlProps: PropTypes.object.isRequired,
        id: PropTypes.string,
    };

    /**
     * DefaultProps
     */
    static defaultProps = {
        value: null,
        formControlProps: {},
    };

    /**
     * Context Types
     *
     * @type Object
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    handleChange = event => {
        const { onChange } = this.props;
        onChange(event.target.value);
    };

    render() {
        const { classes, value, options, placeholder, id, formControlProps, ...libraryParams } = this.props;
        const { intl: { formatMessage } } = this.context;

        return (
            <FormControl fullWidth {...formControlProps}>
                {value === null &&
                    <InputLabel className={classes.label} htmlFor={id}>{formatMessage({ id: placeholder })}</InputLabel>
                }
                <Select
                    className={classes.select}
                    value={value === null ? '': value}
                    {...libraryParams}
                    onChange={this.handleChange}
                >
                    {options.map(item => (
                        <MenuItem key={item.value} value={item.value}>
                            {item.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/CustomSelect/CustomSelect.jsx